'use client'

import { cn } from '@/lib/utils'

interface PillOption {
  label: string
  value: string
}

interface FilterPillsProps {
  label: string
  options: PillOption[]
  value: string
  onChange: (value: string) => void
}

export function FilterPills({ label, options, value, onChange }: FilterPillsProps) {
  return (
    <div>
      <p className="text-[11px] font-medium uppercase tracking-wider text-muted mb-2">
        {label}
      </p>
      <div className="flex flex-wrap gap-1.5" role="radiogroup" aria-label={label}>
        {options.map((option) => (
          <button
            key={option.value}
            type="button"
            role="radio"
            aria-checked={value === option.value}
            onClick={() => onChange(option.value)}
            className={cn(
              'px-3 py-1.5 rounded-full text-xs font-medium whitespace-nowrap transition-colors cursor-pointer',
              value === option.value
                ? 'bg-accent text-accent-foreground'
                : 'bg-overlay text-foreground hover:bg-overlay/80',
            )}
          >
            {option.label}
          </button>
        ))}
      </div>
    </div>
  )
}
